import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Chinese%20cinema%20stage%20with%20warm%20golden%20spotlight%20and%20red%20velvet%20curtains%2C%20dramatic%20theater%20lighting%2C%20cinematic%20atmosphere%2C%20elegant%20movie%20premiere%20backdrop%2C%20soft%20bokeh%20effects%2C%20luxurious%20dark%20warm%20tones&width=1920&height=1080&seq=hero-bg-chengquan&orientation=landscape"
        alt="成全影视 - 高清免费在线影视平台"
        className="w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/60"></div>

      <div className="absolute inset-0 flex items-center justify-center">
        <div className="text-center px-4 w-full max-w-3xl">
          <h1 className="font-heading text-2xl md:text-4xl lg:text-5xl font-bold text-white leading-tight">
            高清免费影视，尽在
            <span className="text-accent-400">成全影视</span>
          </h1>
          <p className="mt-4 md:mt-5 text-sm md:text-base text-background-200 max-w-xl mx-auto leading-relaxed">
            海量高清电影、电视剧、动漫、综艺免费在线观看，无需VIP，流畅追剧一网打尽
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mt-6 md:mt-8">
            <Link
              to="/category/movie"
              className="inline-flex items-center gap-2 px-6 py-2.5 bg-primary-500 hover:bg-primary-600 text-white text-sm font-medium rounded-full transition-all whitespace-nowrap cursor-pointer"
            >
              <i className="ri-play-circle-line text-lg w-5 h-5 flex items-center justify-center"></i>
              开始观影
            </Link>
            <Link
              to="/category/tv"
              className="inline-flex items-center gap-2 px-6 py-2.5 bg-white/10 hover:bg-white/20 text-white text-sm font-medium rounded-full backdrop-blur-sm transition-all whitespace-nowrap cursor-pointer border border-white/20"
            >
              <i className="ri-tv-line text-lg w-5 h-5 flex items-center justify-center"></i>
              热门剧集
            </Link>
          </div>
          <div className="flex items-center justify-center gap-6 mt-6 md:mt-8">
            <div className="text-center">
              <p className="text-white font-heading text-lg md:text-xl font-bold">10万+</p>
              <p className="text-background-400 text-xs mt-1">影视资源</p>
            </div>
            <div className="w-px h-8 bg-white/20"></div>
            <div className="text-center">
              <p className="text-white font-heading text-lg md:text-xl font-bold">4K</p>
              <p className="text-background-400 text-xs mt-1">高清画质</p>
            </div>
            <div className="w-px h-8 bg-white/20"></div>
            <div className="text-center">
              <p className="text-white font-heading text-lg md:text-xl font-bold">免费</p>
              <p className="text-background-400 text-xs mt-1">无需VIP</p>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-4 md:bottom-8 left-1/2 -translate-x-1/2">
        <div className="w-6 h-10 rounded-full border-2 border-white/30 flex items-start justify-center p-1.5">
          <div className="w-1 h-2.5 rounded-full bg-white/60 animate-bounce"></div>
        </div>
      </div>
    </section>
  );
}